import type { OfferItem } from '../types/offer'

export const offerItems: OfferItem[] = [
  {
    id: 'bible',
    kicker: '📘 Producto Principal',
    title: 'The Visual Disruption Bible 2.0',
    description:
      'El manual maestro con la metodología de bloques de tiempo y narrativa disruptiva.',
    value: '$197',
    image:
      'https://cdn.magicpatterns.com/uploads/aQrEqRjMdYQhRSjtcsxmtn/Visual_bible.png',
    alt: 'Portada de The Visual Disruption Bible 2.0'
  },
  {
    id: 'bono-1',
    kicker: '📗 Bono 1',
    title: 'The Command Console',
    description:
      '200 prompts de imagen clasificados por industria. E-commerce, Real Estate, Lujo y más.',
    value: '$97',
    image:
      'https://cdn.magicpatterns.com/uploads/hMYjwLrGNdCW4ryk77ssVK/BONO-1.png',
    alt: 'Portada del Bono 1 — The Command Console'
  },
  {
    id: 'bono-2',
    kicker: '📗 Bono 2',
    title: 'Action Sequence Scripts',
    description:
      '200 guiones cinemáticos con física imposible y transiciones de portal.',
    value: '$67',
    image:
      'https://cdn.magicpatterns.com/uploads/ppfTjuJJQaDUg9D3ATjS7X/BONO-2.png',
    alt: 'Portada del Bono 2 — Action Sequence Scripts'
  },
  {
    id: 'bono-3',
    kicker: '📗 Bono 3',
    title: 'The Hook Library',
    description:
      '200 triggers visuales diseñados para reventar tu CTR en Meta Ads y TikTok.',
    value: '$47',
    image:
      'https://cdn.magicpatterns.com/uploads/iGdtqaugGZLtvpExwF5Uxf/BONO-3.png',
    alt: 'Portada del Bono 3 — The Hook Library'
  },
  {
    id: 'bono-4',
    kicker: '📗 Bono 4',
    title: 'Commercial & Agency Rights',
    description:
      'El manual de 150 tácticas para vender estos servicios a clientes por miles de dólares.',
    value: '$97',
    image:
      'https://cdn.magicpatterns.com/uploads/nPfh4h89ghHBc7Rtk7ETJE/BONO-4.png',
    alt: 'Portada del Bono 4 — Commercial & Agency Rights'
  },
  {
    id: 'bono-5',
    kicker: '📗 Bono 5',
    title: 'VIP Community Access',
    description:
      'Acceso gratuito a "Start Launching Creatives" en Skool. Soporte, networking y actualizaciones de por vida.',
    value: 'GRATIS',
    isFree: true,
    image:
      'https://cdn.magicpatterns.com/uploads/5gCrrqdWMNZ7ZkjKuoaKZk/BONO-5.png',
    alt: 'Acceso VIP a la comunidad Start Launching Creatives en Skool'
  }
]
